<div class="dynamic-content-table-container">
  <div class="loader-container" *ngIf="showLoader"><mat-spinner></mat-spinner></div>
  <div class="header">
    <div class="title">{{ translations?.pages?.['dynamic-content'] }}</div>
    <div class="search">
      <mat-form-field class="search-field">
        <input (keyup)="search()" [(ngModel)]="searchValue" matInput [placeholder]="translations?.general?.search">
      </mat-form-field>
    </div>
    <div class="actions">
      <button (click)="addFromGlobal()" *ngIf="globalEntries?.length" matTooltipPosition="left">
        <mat-icon>create_new_folder</mat-icon>
      </button>
      <button (click)="add()" *ngIf="!entrance.readonly" [matTooltip]="translations?.dynamicContent?.addEntry" matTooltipPosition="left"
              class="add-button">
        <mat-icon>add</mat-icon>
      </button>
      <ng-container *ifPrivilege="{name: 'write', value: 'pipe-imports'}">
        <button (click)="reloadPipeData()" *ngIf="showReloadPipeData && !showInitPipeData" [matTooltip]="translations?.general?.executePipe" matTooltipPosition="left">
          <mat-icon>autorenew</mat-icon>
        </button>

        <button (click)="initPipeData()" *ngIf="showInitPipeData" [matTooltip]="translations?.general?.executePipeNewFile" matTooltipPosition="left">
          <mat-icon>backup</mat-icon>
        </button>
      </ng-container>
    </div>
  </div>

  <div class="action-header" [ngClass]="{ active: !!selectedItems?.length }">
    <div
      class="count">{{ selectedItems?.length }} {{ 'general.selectedEntries' + (selectedItems.length > 1 ? 'Multi' : 'Single') | translate }}
    </div>
    <mat-form-field *ngIf="checkBoxActions">
      <mat-select [disabled]="!selectedItems?.length" [placeholder]="translations?.general?.selectionActions" #actionHeaderSelect>
        <mat-option (click)="action.action()" *ngFor="let action of checkBoxActions">
          <mat-icon *ngIf="action.icon">{{ action.icon }}</mat-icon>{{ action.translation | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div class="actions"><mat-icon (click)="selectAll('unselect')">close</mat-icon></div>
  </div>

  <div class="sub-header">
    <input (click)="selectAll()" type="checkbox" [checked]="allSelected()">
    <div class="title">{{ translations?.general?.title }}</div>
    <div *ngIf="entrance.type === 'alphabet'" class="good-to-know">{{ translations?.dynamicContent?.goodToKnow }}</div>
    <div *ngIf="['activity', 'event'].includes(entrance.type)" class="next-execution">{{ 'general.' + (archive ? 'last' : 'next') + 'Execution' | translate }}</div>
    <div class="drag" *ngIf="!entrance.readonly && !noDragAndDropItems.includes(type || entrance.type) && !liveData">
      <mat-icon>keyboard_arrow_up</mat-icon><mat-icon>keyboard_arrow_down</mat-icon>
    </div>
    <div class="categories" *ngIf="categories?.length">{{ translations?.dynamicContent?.categories }}</div>
    <div class="order" *ngIf="showOrder">{{ translations?.dynamicContent?.order }}</div>
    <div class="state">{{ translations?.general?.state }}</div>
    <div class="languages" *ngIf="!short">{{ translations?.general?.languages?.title }}</div>
    <div class="created" *ngIf="!medium">{{ translations?.general?.created }}</div>
    <div class="actions"><mat-icon style="opacity: 0">help</mat-icon></div>
  </div>
  <div *ngIf="!!data?.length" cdkDropList [cdkDropListData]="items" class="list" (cdkDropListDropped)="drop($event)"
       [ngClass]="{ 'drop-disabled': !!searchValue?.length || (noDragAndDropItems.includes(entrance.type) && type !== 'category') || !!liveData }"
       [cdkDropListDisabled]="!!searchValue?.length || entrance.readonly || (noDragAndDropItems.includes(entrance.type) && type !== 'category') || !!liveData">
    <ng-container *ngFor="let item of items">
      <div class="item level-{{item.level + 1}}" cdkDrag #dragRef="cdkDrag" [ngClass]="{ hidden: isItemHidden(item) }" *ngIf="!item.hidden"
           cdkDragBoundary=".list" (click)="edit(item)">
        <div class="placeholder" *cdkDragPlaceholder></div>
        <div class="drag-handle" cdkDragHandle
             *ngIf="!entrance.readonly && !noDragAndDropItems.includes(type || entrance.type) && !liveData"
             [matTooltip]="translations?.packages?.installedApps?.dragTip">
          <mat-icon>drag_indicator</mat-icon>
        </div>
        <dynamic-content-table-row [item]="item" [type]="type || entrance.type" [categories]="categories" [searchValue]="searchValue"
                                   [noCategories]="false" id="{{item.data._id}}" (onToggleChildren)="toggleSub(item)" [archive]="archive"
                                   (onSelect)="select(item)" (onEdit)="edit(item)" (onDetail)="detail(item)" (onAddChild)="addChild(item)"
                                   (onPreview)="preview(item)" [showPreview]="showPreview" [app]="app" [showOrder]="showOrder"
                                   [forceCategories]="false" [dragRef]="dragRef" (onDelete)="delete(item)" [readOnly]="entrance.readonly">
        </dynamic-content-table-row>
      </div>
    </ng-container>
  </div>

  <div class="empty" *ngIf="!data?.length">{{ translations?.dynamicContent?.noEntries }}</div>
</div>
